export enum StepActionType {
    MESSAGE = 'Message',
    HIGHLIGHT = 'Highlight',
    ACTION = 'Action',
    REFRESH_BACKWARDS = 'Refresh Backwards',
    REFRESH_FORWARD = 'Refresh Forward',
    RESTARTING_ACTION = 'Restarting Action'
}
